import React, { useState, useEffect } from 'react';
import { Brain, Users, Code, Globe, Cpu, Atom, ChevronLeft, ChevronRight } from 'lucide-react';
import './WhyJoin.css';

const BenefitCard = ({ Icon, title, description }) => {
  if (!Icon) return null;
  
  return (
    <div className="quantum-benefit-card">
      <Icon className="quantum-benefit-icon" size={32} />
      <h3 className="quantum-benefit-title">{title}</h3>
      <p className="quantum-benefit-text">{description}</p>
    </div>
  );
};

const QuantumKESection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSliderView, setIsSliderView] = useState(false);

  const benefits = [
    {
      Icon: Brain,
      title: "Cutting-edge Knowledge",
      description: "Access the latest quantum computing research and breakthroughs."
    },
    {
      Icon: Users,
      title: "Vibrant Community",
      description: "Connect with like-minded individuals passionate about quantum technology."
    },
    {
      Icon: Code,
      title: "Hands-on Projects",
      description: "Collaborate on real-world quantum computing projects and experiments."
    },
    {
      Icon: Globe,
      title: "Global Network",
      description: "Engage with quantum experts and enthusiasts from around the world."
    },
    {
      Icon: Cpu,
      title: "Resource Hub",
      description: "Explore our comprehensive library of quantum computing resources."
    },
    {
      Icon: Atom,
      title: "Quantum Workshops",
      description: "Participate in interactive workshops and training sessions."
    }
  ];

  // Check screen size and update slider view
  useEffect(() => {
    const checkScreenSize = () => {
      setIsSliderView(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % benefits.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + benefits.length) % benefits.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="quantum-section">
      <div className="quantum-container">
        <h2 className="quantum-heading">Why Join QuantumKE ?</h2>
        
        {isSliderView ? (
          <div className="quantum-slider">
            <div className="quantum-slider-container">
              <button 
                className="quantum-slider-btn quantum-slider-btn-prev"
                onClick={prevSlide}
                aria-label="Previous slide"
              >
                <ChevronLeft size={24} />
              </button>
              
              <div className="quantum-slider-track">
                <div 
                  className="quantum-slider-content"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {benefits.map((benefit, index) => (
                    <div key={index} className="quantum-slider-item">
                      <BenefitCard
                        Icon={benefit.Icon}
                        title={benefit.title}
                        description={benefit.description}
                      />
                    </div>
                  ))}
                </div>
              </div>
              
              <button 
                className="quantum-slider-btn quantum-slider-btn-next"
                onClick={nextSlide}
                aria-label="Next slide"
              >
                <ChevronRight size={24} />
              </button>
            </div>
            
            <div className="quantum-slider-dots">
              {benefits.map((_, index) => (
                <button
                  key={index}
                  className={`quantum-slider-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="quantum-benefits-grid">
            {benefits.map((benefit, index) => (
              <BenefitCard
                key={index}
                Icon={benefit.Icon}
                title={benefit.title}
                description={benefit.description}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default QuantumKESection;